import React, { useEffect, useState } from 'react';

import InputSelectField from "./InputSelectField";
import DatePicker from "react-datepicker";
import InputCurrencyField from './InputCurrencyField';
import InputTextField from './InputTextField';
import './InvoiceOverpaymentCreditTable.scss';

const InvoiceOverpaymentCreditTable = ({ applicationTypes, paymentApplicationDate, dateConfig, onChange, isConfirmInitiated, overPaymentAmount, accountingMethod }) => {
  const [creditData, setCreditData] = useState({
    application_type: accountingMethod,
    application_date: paymentApplicationDate,
    amount: null,
    amount_tax_1: null,
    amount_tax_2: null,
    amount_tax_3: null,
    amount_tax_4: null
  });


  const isApplyCash = creditData.application_type === 'APPLY_CASH';



  const amountValidator = (value) => !isNaN(value) && value >= 0;
  const amountValidatorText = (
    <div className="parkchirp--invoice-overpayment-credit-table--cell--error-amountValidatorText">
      Amount must be POSITIVE.
    </div>
  )

  // Update local state and parent state on value changes
  const _onValueChange = key => value => {
    setCreditData(prevState => ({
      ...prevState,
      [key]: value
    }));
  };

  useEffect(() => {
    if (isApplyCash === false) {
      setCreditData({
        application_type: accountingMethod,
        application_date: null,
        amount: overPaymentAmount,
        amount_tax_1: null,
        amount_tax_2: null,
        amount_tax_3: null,
        amount_tax_4: null
      })
    }
    // Set the overpayment credit to null on unmount
    return () => {
      onChange(null);
    };
  }, []);

  useEffect(() => {
    // Update parent data on any change to local state
    onChange(creditData);
  }, [creditData]);

  useEffect(() => {
    // Enable/disable application date based on application type
    const newState = {
      application_date: null,
      application_type: 'DO_NOT_APPLY_CASH',
      amount: null,
      amount_tax_1: null,
      amount_tax_2: null,
      amount_tax_3: null,
      amount_tax_4: null
    };
    if (creditData.application_type === 'DO_NOT_APPLY_CASH') {
      newState.amount = overPaymentAmount;
      setCreditData(prevState => ({
        ...prevState,
        ...newState
      }));
      onChange(newState);
    } else if (creditData.application_type === 'APPLY_CASH') {
      newState.application_type = 'APPLY_CASH';
      newState.application_date = paymentApplicationDate;
      setCreditData(prevState => ({
        ...prevState,
        ...newState
      }));
    }
  }, [creditData.application_type]);

  useEffect(() => {
    // Update application date based on changes to payment application date
    if (isApplyCash) {
      _onValueChange('application_date')(paymentApplicationDate);
    }
  }, [paymentApplicationDate]);

  useEffect(() => {
    // Update net and gross amounts based on changes to over payment amount
    if (!isApplyCash) {
      const newState = {
        application_date: null,
        application_type: 'DO_NOT_APPLY_CASH',
        amount: overPaymentAmount,
        amount_tax_1: null,
        amount_tax_2: null,
        amount_tax_3: null,
        amount_tax_4: null
      };
      setCreditData(prevState => ({
        ...prevState,
        ...newState
      }));
      onChange(newState);
    } else if (isApplyCash) {
      _onValueChange('amount')(overPaymentAmount);
    }
  }, [overPaymentAmount]);

  return (
    <div className="parkchirp--invoice-overpayment-credit-table">
      <header className="parkchirp--invoice-overpayment-credit-table--header parkchirp--invoice-overpayment-credit-table-row">
        <div className="parkchirp--invoice-overpayment-credit-title-column parkchirp--invoice-overpayment-credit-table--cell">
          <span className="parkchirp--invoice-overpayment-credit-table--column-heading">Application Type</span>
        </div>
        <div className="parkchirp--invoice-overpayment-credit-parker-name-column parkchirp--invoice-overpayment-credit-table--cell">
          <span className="parkchirp--invoice-overpayment-credit-table--column-heading">Credit Application Date</span>
        </div>
        <div className="parkchirp--overpayment-credit-net-amount-column parkchirp--invoice-overpayment-credit-table--cell">
          <span className="parkchirp--invoice-overpayment-credit-table--column-heading">Net Amount</span>
        </div>
        <div className="parkchirp--overpayment-credit-amount-tax-1-column parkchirp--invoice-overpayment-credit-table--cell">
          <span className="parkchirp--invoice-overpayment-credit-table--column-heading">Tax 1</span>
        </div>
        <div className="parkchirp--overpayment-credit-amount-tax-2-column parkchirp--invoice-overpayment-credit-table--cell">
          <span className="parkchirp--invoice-overpayment-credit-table--column-heading">Tax 2</span>
        </div>
        <div className="parkchirp--overpayment-credit-amount-tax-3-column parkchirp--invoice-overpayment-credit-table--cell">
          <span className="parkchirp--invoice-overpayment-credit-table--column-heading">Tax 3</span>
        </div>
        <div className="parkchirp--overpayment-credit-amount-tax-4-column parkchirp--invoice-overpayment-credit-table--cell">
          <span className="parkchirp--invoice-overpayment-credit-table--column-heading">Tax 4</span>
        </div>
        <div className="parkchirp--invoice-overpayment-credit-balance-column parkchirp--invoice-overpayment-credit-table--cell">
          <span className="parkchirp--invoice-overpayment-credit-table--column-heading">Gross Amount</span>
        </div>
      </header>
      <div className="parkchirp--invoice-overpayment-credit-table--body">
        <div className="parkchirp--invoice-overpayment-credit-table-row">
          <div className="parkchirp--invoice-overpayment-credit-table--cell">
            <InputSelectField
              inputId={`parkchirp--invoice-overpayment-credit--application-type`}
              options={applicationTypes.options}
              onChange={_onValueChange('application_type')}
              value={creditData.application_type}
              editMode={true}
              disabledMode={true}
            />
          </div>
          <div className="parkchirp--invoice-overpayment-credit-table--cell">
            {isApplyCash &&
              <DatePicker
                id={`parkchirp--invoice-overpayment-credit--application-date`}
                containerClasses={['parkchirp--payment-input-block']}
                layout="stacked"
                disabled={isConfirmInitiated}
                selected={creditData.application_date}
                onChange={_onValueChange('application_date')}
                excludeDates={dateConfig.exclude}
                minDate={dateConfig.minDate}
                maxDate={dateConfig.maxDate}
              />
            }
            {!isApplyCash &&
              <InputTextField
                disabledMode={true}
                inputId={`parkchirp--invoice-overpayment-credit--tax-1`}
                value={"-"}
                editMode={false}
              />
            }
          </div>
          <div className="parkchirp--invoice-overpayment-credit-table--cell">
            <InputCurrencyField
              disabledMode={isConfirmInitiated}
              inputId={`parkchirp--invoice-overpayment-credit--net-amount`}
              value={creditData.amount}
              onChange={_onValueChange('amount')}
              editMode={isApplyCash}
              checkNegative={true}
              validator={amountValidator}
              validatorText={amountValidatorText}
            />
          </div>
          <div className="parkchirp--invoice-overpayment-credit-table--cell">
            {isApplyCash &&
              <InputCurrencyField
                disabledMode={isConfirmInitiated}
                inputId={`parkchirp--invoice-overpayment-credit--tax-1`}
                editMode={true}
                value={creditData.amount_tax_1}
                onChange={_onValueChange('amount_tax_1')}
                checkNegative={true}
                validator={amountValidator}
                validatorText={amountValidatorText}
              />
            }
            {!isApplyCash &&
              <InputTextField
                disabledMode={true}
                inputId={`parkchirp--invoice-overpayment-credit--tax-1`}
                value={"-"}
                editMode={false}
              />
            }
          </div>
          <div className="parkchirp--invoice-overpayment-credit-table--cell">
            {isApplyCash &&
              <InputCurrencyField
                disabledMode={isConfirmInitiated}
                inputId={`parkchirp--invoice-overpayment-credit--tax-2`}
                editMode={true}
                value={creditData.amount_tax_2}
                onChange={_onValueChange('amount_tax_2')}
                checkNegative={true}
                validator={amountValidator}
                validatorText={amountValidatorText}
              />
            }
            {!isApplyCash &&
              <InputTextField
                disabledMode={true}
                inputId={`parkchirp--invoice-overpayment-credit--tax-2`}
                value={"-"}
                editMode={false}
              />
            }
          </div>
          <div className="parkchirp--invoice-overpayment-credit-table--cell">
            {isApplyCash &&
              <InputCurrencyField
                disabledMode={isConfirmInitiated}
                inputId={`parkchirp--invoice-overpayment-credit--tax-3`}
                onChange={_onValueChange('amount_tax_3')}
                value={creditData.amount_tax_3}
                editMode={true}
                checkNegative={true}
                validator={amountValidator}
                validatorText={amountValidatorText}
              />
            }
            {!isApplyCash &&
              <InputTextField
                disabledMode={true}
                inputId={`parkchirp--invoice-overpayment-credit--tax-3`}
                value={"-"}
                editMode={false}
              />
            }
          </div>
          <div className="parkchirp--invoice-overpayment-credit-table--cell">
            {isApplyCash &&
              <InputCurrencyField
                disabledMode={isConfirmInitiated}
                inputId={`parkchirp--invoice-overpayment-credit--tax-4`}
                onChange={_onValueChange('amount_tax_4')}
                editMode={true}
                value={creditData.amount_tax_4}
                checkNegative={true}
                validator={amountValidator}
                validatorText={amountValidatorText}
              />
            }
            {!isApplyCash &&
              <InputTextField
                disabledMode={true}
                inputId={`parkchirp--invoice-overpayment-credit--tax-4`}
                value={"-"}
                editMode={false}
              />
            }
          </div>
          <div className="parkchirp--invoice-overpayment-credit-table--cell">
            <InputCurrencyField
              disabledMode={isConfirmInitiated}
              inputId={`parkchirp--invoice-overpayment-credit--gross-amount`}
              value={overPaymentAmount}
              editMode={false}
              checkNegative={true}
            />
          </div>
        </div>
        {isApplyCash && !creditData.application_date &&
          <div className="parkchirp--invoice-overpayment-credit-table-row parkchirp--invoice-overpayment-credit-table--error-row">
            <div className="parkchirp--invoice-overpayment-credit-table--cell">
            </div>
            <div className="parkchirp--invoice-overpayment-credit-table--cell">
              <span className='error'>Provide a valid date</span>
            </div>
            <div className="parkchirp--invoice-overpayment-credit-table--cell">
            </div>
            <div className="parkchirp--invoice-overpayment-credit-table--cell">
            </div>
            <div className="parkchirp--invoice-overpayment-credit-table--cell">
            </div>
            <div className="parkchirp--invoice-overpayment-credit-table--cell">
            </div>
            <div className="parkchirp--invoice-overpayment-credit-table--cell">
            </div>
            <div className="parkchirp--invoice-overpayment-credit-table--cell">
            </div>
          </div>
        }
      </div>
    </div>
  );
}

export default InvoiceOverpaymentCreditTable;
